import React from "react";
import { Link } from "react-router-dom";

const DiseaseAreas = () => {
  const categories = [
    "Oncology",
    "Rheumatology",
    "Cardiology",
    "Gastroenterology",
    "Dermatology",
    "Urology",
    "Gynecology",
    "Infectious Disease",
    "Endocrinology",
    "Pulmonology",
    "Neurology",
    "Orthopedic",
    "Nephrology",
    "General Medicine",
    "Hematology",
  ];

  return (
    <section className="py-8 md:py-16 px-4 bg-white font-sans">
      <div className="max-w-[1800px] mx-auto text-center">
        {/* Title */}
        <h2 className="text-[24px] md:text-[30px] lg:text-[40px] 2xl:text-[60px] font-bold text-[#183076] mb-4">
          Disease Areas & Patient Populations
        </h2>

        {/* Subtitle */}
        <p className=" mb-10 text-[18px] md:text-[24px]">
          Filter specimens by therapeutic area to quickly identify samples
          aligned with your research objectives.
        </p>

        {/* Categories Grid/Flex */}
        <div className="flex flex-wrap justify-center gap-[20px] md:gap-[30px]">
          {categories.map((area, index) => (
            <Link
              key={index}
              to="/biospecimens-category"
              className=" px-[14px] md:px-[20px] xl:px-[40px]  py-[10px] md:py-[18px] xl:py-[28px] border-2 text-[20px] md:text-[24px] 2xl:text-[30px] border-[#183076] text-[#183076] font-medium rounded-[20px]
                         transition-all duration-300 ease-in-out
                         hover:bg-[#183076] hover:text-white hover:shadow-lg active:scale-95 w-full sm:w-auto text-center"
            >
              {area}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DiseaseAreas;
